import resolvePromise from '../helper/resolved_promise';
import ProductBatchStocksConstants from '../constants/product_batch_stocks_constants';
import Dispatcher from '../dispatcher';

function setProductBatchStocksAction(products) {
    Dispatcher.handleProductBatchStocksAction({
        type: ProductBatchStocksConstants.SET_PRODUCT_BATCH_STOCKS,
        payload: products
    });

    return resolvePromise();
}

function setActiveProductBatchStocksAction(products) {
    Dispatcher.handleProductBatchStocksAction({
        type: ProductBatchStocksConstants.SET_ACTIVE_PRODUCT_BATCH_STOCKS,
        payload: products
    });

    return resolvePromise();
}

function unsetActiveProductBatchStocksAction() {
    Dispatcher.handleProductBatchStocksAction({
        type: ProductBatchStocksConstants.UNSET_ACTIVE_PRODUCT_BATCH_STOCKS
    });

    return resolvePromise();
}

export {
    setProductBatchStocksAction,
    setActiveProductBatchStocksAction,
    unsetActiveProductBatchStocksAction,
};
